import { render, staticRenderFns } from "./HouseStatTab.vue?vue&type=template&id=62e4c300&scoped=true&"
import script from "./HouseStatTab.vue?vue&type=script&lang=js&"
export * from "./HouseStatTab.vue?vue&type=script&lang=js&"
import style0 from "./HouseStatTab.vue?vue&type=style&index=0&id=62e4c300&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4c300",
  null
  
)

export default component.exports